/*
  raffle-component.ts
  Golfhubber
  Created by Chetan Baghel on 28/09/2021.
  Copyright © 2021 Golfhubber Ltd. All rights reserved.
*/

import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
// import { UtilityService } from 'src/app/service/utility.service';

import { ApiService } from 'app/services/api';
import { ExcelService } from 'app/services/excel.service';
import { OAuthService } from 'app/services/o-auth';
import { UtilityService } from 'app/services/utility/utility.service';
import * as moment from 'moment';

@Component({
  selector: 'app-raffle-component',
  templateUrl: './raffle-component.component.html',
  styleUrls: ['./raffle-component.component.scss']
})
export class RaffleComponent implements OnInit {

  public imageLoader: boolean = false;
  public raffleList: Array<any>;
  public displayRaffleList: Array<any>;
  public filters: any;
  public showButtons = false;
  public user: any;
  public displayRaffleLists : boolean = true;
  public showCompetitions : boolean = false;
 
  // fireDatabase: any;
  constructor(
    public apiService: ApiService,
    public oAuthService: OAuthService,
    private excelService: ExcelService,
    private fireDatabase: AngularFireDatabase, 
    private utilityService: UtilityService,
  ) { }

  async ngOnInit() {
    this.user = this.oAuthService.getClub();
    this.getRaffleList();
    this.counter();
  
  }
  counter() {
    let self = this
    let x = setInterval(function () {
      if (self.raffleList && self.raffleList.length > 0) {
      
      for (let raffle of self.raffleList) {
        Object.assign(raffle, { counter: self.utilityService.counterFromCurrentDate(moment(raffle.drawDate)) });
      }
    }

    }, 1000);
  }

  async getRaffleList() {
    this.filters = { startDate: "", status: 0 };
    this.imageLoader = true;
    try {
       this.fireDatabase.database.ref('/raffles').on("value", async (result) => {      
        if (result.val()) {
          let raffleList = [];
          for (let key in result.val()) {
            let raffle = result.val()[key];
            if (raffle.status)
            {
              Object.assign(raffle, { $key: key, diff: this.utilityService.diffYMDHMS(moment(raffle.endDate), moment(raffle.startDate)) });
              Object.assign(raffle, { counter: this.utilityService.counterFromCurrentDate(moment(raffle.drawDate)) })
              raffleList.push(raffle);
            }
          }
          raffleList.sort((a, b) => {
            return (new Date(a.startDate)).getTime() - (new Date(b.startDate)).getTime();
          });
          let list = [];
          raffleList.forEach(raffle => {
            raffle.isSelected = false;
            if (raffle.userId == this.user.uid && raffle.uid == this.user.cid) {
              list.push(raffle);
            }
          });

          this.raffleList = list;
          this.displayRaffleList = this.raffleList;
          this.raffleList = raffleList;
        }
        else this.raffleList = [];
         
         this.imageLoader = false;
      });
    }
    catch{
      this.imageLoader = false;
    }

    this.imageLoader = false;
  }

  filterChange() {


    if(this.filters.status != 0 && !this.filters.startDate) { // just status
      this.displayRaffleList = this.raffleList.filter((element) => 
        element.status == this.filters.status
      );
    }    
    else if (this.filters.status != 0 && this.filters.startDate) { //both filters
      this.displayRaffleList = this.raffleList.filter(
        (x) =>
        {
          if (x.startDate)
          {
            let temp1 = new Date(x.startDate).toDateString();
            let temp2 = new Date(this.filters.startDate).toDateString();
            return temp1 == temp2 
          } else return false
        }
      );
       this.displayRaffleList = this.displayRaffleList.filter((element) => 
        element.status == +this.filters.status
       );
    }
    else if(this.filters.status == 0 && !this.filters.startDate) { //no filter
      this.displayRaffleList = this.raffleList
    }
    else { //just startDate
      this.displayRaffleList = this.raffleList.filter(
        (x) =>
        {
          if (x.startDate)
          {
            let temp1 = new Date(x.startDate).toDateString();
            let temp2 = new Date(this.filters.startDate).toDateString();
            return temp1 == temp2;
          } else return false
        }
      );
    }
  }

 activate(item) {
   if (confirm("Are you sure,you want to Activate the Raffle?")) {
      this.imageLoader = true;
      if (item.status == 3 || item.status == 2) {
        this.apiService
          .set(`/raffles/${item.$key}/status`, 1)
          .then(() => {
            location.reload();
          })
      }
    }
  }

 deactivate(item) {
   if (confirm("Are you sure,you want to Deactivate the Raffle?")) {
      this.imageLoader = true;
      if (item.status == 1 || item.status == 3) {
        this.apiService
          .set(`/raffles/${item.$key}/status`, 2)
          .then(() => {
            location.reload();
          })
      }
    }
  }

  async deactivateAll() {
    if (confirm("Are you sure,you want to Deactivate all Raffles?")) {
      this.imageLoader = true;
      for (let raffle of this.displayRaffleList)
      {
        if ((raffle.status == 3 || raffle.status == 1) && raffle.isSelected)
        {
          await this.apiService
            .set(`/raffles/${raffle.$key}/status`, 2)
            .then(() => {
              
            })

        }
      }
      
      location.reload();
    }
  }

  async activateAll() {
    if (confirm("Are you sure,you want to Activate all Raffles?")) {
      this.imageLoader = true;
      for (let raffle of this.displayRaffleList)
      {
        if (raffle.status == 2 && raffle.isSelected)
        {
          await this.apiService
            .set(`/raffles/${raffle.$key}/status`, 1)
            .then(() => {
              
            });

        }
      }
      location.reload();
    }
  }

  resetFilters() {
    this.displayRaffleList = this.raffleList;
    this.filters = { startDate: "", status: 0 };
  }
  public raffleSelect(event, offer) {
    offer.isSelected = event.checked;
    let oneSelected = false;
    var i = 0;
    for (i = 0; i < this.displayRaffleList.length; i++) {
      if (this.displayRaffleList[i].isSelected) {
        oneSelected = true;
      }
    }
    if (oneSelected) {
      this.showButtons = true;
    } else {
      this.showButtons = false;
    }
  }

  checkAll(checked) {
    this.showButtons = checked;
    this.displayRaffleList.forEach(raffle => {
      raffle.isSelected = checked;
    });
  }
  toggleShow() {
    
    this.displayRaffleLists = true;
    if(this.showCompetitions){
      this.showCompetitions = false;
    
    }
    // toggleShowNone(){

    // }
    
    }
    toggleShow2(){
      this.showCompetitions = true;
      if(this.displayRaffleLists){
        this.displayRaffleLists =false;
      }
    }
    // toggleShow2None(){

    // }

  

  

  exportRaffles() {
    let objectArray = [];
    this.raffleList.forEach(function (raffle) { 

      let raffle_status;
      if (raffle.status == 1) raffle_status = "Active";
      else if (raffle.status == 2) raffle_status = "Inactive";
      else if (raffle.status == 3) raffle_status = "Pending";
      else if (raffle.status == 4) raffle_status = "Expired";

      let object = { 
        raffleId: raffle.$key,
        name: raffle.name,
        startDate: raffle.startDate,
        endDate: raffle.endDate,
        drawDate: new Date(raffle.drawDate).toDateString(),
        rafflePrice: raffle.ticketPrice,
        createdAt: new Date(raffle.createdAt).toDateString(),
        sold: raffle.sold,
        stock: raffle.stock,
        status: raffle_status
        }
      objectArray.push(object);
    });

    this.excelService.exportAsExcelFile(objectArray, "export");
  }

}
